export const getNameInitials = (fullName: string) => {
  if (!fullName) {
    return '';
  }
  const names = fullName.split(' ');
  if (names.length === 0) {
    return '';
  }
  if (names.length === 1) {
    return names[0][0];
  }
  return `${names[0][0]}${names[names.length - 1][0]}`;
};
